// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"upperSection_wrapper__2-okv"};